<div class="h-full flex flex-col " [ngClass]="elementClass">
  @if(showClose){
  <div class="flex justify-end px-3">
    <button class="text-2xl" name="close" title="close" (click)="closeOverlay()"><i class="bi bi-x-circle"></i></button>
  </div>
  }
  <div class="content px-1 grow">
    <ng-template #dynamicContent></ng-template>
  </div>
</div>